import { lazy } from "react";


const DateWise = lazy(() => import("./DateWise"));
const DateWiseDetail = lazy(() => import("./DateWiseDetail"));
const EmployeeWise = lazy(() => import("./EmployeeWise"));
const EmployeeWiseDetail = lazy(() => import("./EmployeeWiseDetail"));
const MachineWise = lazy(() => import("./MachineWise"));
const MachineWiseDetail = lazy(() => import("./MachineWiseDetail"));
const PartReport = lazy(() => import("./PartReport"));
const PartReportDetail = lazy(() => import("./PartReportDetail"));
const WorkOrderListReport = lazy(() => import("./WorkOrderListReport"));
const WorkOrderListReportDetail = lazy(() => import("./WorkOrderListReportDetail"));

const reportRoutes = [{
    path: "/reports/date-wise",
    element: <DateWise />,
},
{
    path: "/reports/view_date/:date",
    element: <DateWiseDetail />,
},
{
    path: "/reports/employee-wise",
    element: <EmployeeWise />,
},
{
    path: "/reports/view_employee/:id",
    element: <EmployeeWiseDetail />,
},
{
    path: "/reports/machine-wise",
    element: <MachineWise />,
},
{
    path: "/reports/view_machine/:id",
    element: <MachineWiseDetail />,
},
{
    path: "/reports/part",
    element: <PartReport />,
},
{
    path: "/reports/view_part/:partNumber",
    element: <PartReportDetail />,
},
{
    path: "/reports/work-order-list",
    element: <WorkOrderListReport />,
},
{
    path: "/reports/work-order-list/:type/:id",
    element: <WorkOrderListReportDetail />,
}
]

export default reportRoutes;